<iv-login #ivlogin [srcLogoGeneral]="srcLogoGeneral" [classAccordion]="'classPropio'" [accordionTabs]="accordionTabs"
    [loading]="false" [extras]="extras" (ComeBack)="enviamos($event)" [logo]="srcLogoGeneral" [messages]="messages"
    [autocomplete]="false" [color]="'primary'|colors" [textColor]="'text'|colors" [disableLocalStorage]="true"
    [errorMessages]="errorMessages" (onRecoverPass)="recoverPass($event)" [displayPromo]="displayPromo"
    [promotional]="promotional" (onRedirectSAML)="redirectSAML($event)" [viewSAML]="viewSAML"
    [onlyViewSAML]="onlyViewSAML">
</iv-login>
<signaturit-notification *ngIf="showErrorMessage" id="sig-notification" [timer]="0"
    [customText]="notifMessage"></signaturit-notification>